import SingleQuestionItem from "./SingleQuestionItem";

export default function HelpCenterItem({item}) {
    return (
        <>
        <div className="bg-white mb-[20px]">
            <div className="text-center text-blue cairo-font leading-[50px] h-[50px] font-[700] text-[18px] bg-grey-50 rounded-t-[12px]">{item?.name}</div>
            <div className="p-[12px] border-[1px] border-grey-100 border-t-0 rounded-b-[12px]">
                {item?.questions && Array.isArray(item?.questions) && item?.questions?.length > 0 
                ? item?.questions?.map((question,index)=><SingleQuestionItem key={`question-${index}`} question={question} isFirst={index === 0} />)
                :<div className="text-center text-grey-900 text-[16px] leading-[24px] pb-[15px] mb-[15px] font-[500] cairo-font">لاتوجد اسئلة بعد.</div>}
            </div>
        </div>
        </>
    )
}